<template lang="html">
  <div class="">
    <iframe id="iframeReceipt" name="iframeReceipt" style="height: 0; width: 0"></iframe>
    <div ref="invoice" style="display: none" id="printableArea">
      <div>
        <v-row>
          <v-col cols="6">
            <span class="top-heading">Date:</span><span>{{ moment(currentDate) }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="flex-content" style="
              display: flex;
              margin-top: 10px;
              justify-content: center;
              align-items: center;
              text-transform: uppercase;
            ">
            <img width="150" :src="franchiseeLogo" alt="" />
          </v-col>
          <v-col cols="6" style="text-align: center; margin-top: 10px">
            <p class="franchisee-name">
              {{
                sendCaptureRespos.studentInfo.franchisee.companyName
                ? sendCaptureRespos.studentInfo.franchisee.companyName
                : 'NA'
              }}
            </p>
            <p>
              {{
                sendCaptureRespos.studentInfo.franchisee.trustName
                ? sendCaptureRespos.studentInfo.franchisee.trustName
                : 'N/A'
              }}
            </p>
            <p v-if="sendCaptureRespos.studentInfo.franchisee.tanNo">
              TAN No.-
              {{
                sendCaptureRespos.studentInfo.franchisee.tanNo
                ? sendCaptureRespos.studentInfo.franchisee.tanNo
                : 'N/A'
              }}
            </p>
          </v-col>
          <v-col cols="3" class="flex-content" style="
              display: flex;
              margin-top: 10px;
              justify-content: center;
              align-items: center;
              text-transform: uppercase;
            "><img width="150" :src="tots_image" alt="" /></v-col>
        </v-row>
        <v-divider class="divider" style="margin-top: 6px; border: 1px solid; border-color: black"></v-divider>
        <div class="v-container">
          <v-row>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="4">
                  <span v-if="this.studentDetails && !this.studentDetails.enrollmentCode
                    "><b>Enquiry Code</b> <br /></span>
                  <span><b>Student Name</b></span><br />
                  <span><b>Franchisee Name</b></span><br />
                  <span><b>Academic Year</b></span><br />
                  <span><b>Class</b></span>
                  <br />
                  <span><b>Application Code</b></span><br />
                  <span><b>Student Gender</b></span>
                  <br />
                  <span><b>Section / Division</b></span>
                  <br />
                  <span><b>Enrollment Code</b></span>
                  <br />
                </v-col>
                <v-col cols="8">
                  <span v-if="this.studentDetails && !this.studentDetails.enrollmentCode
                    ">:
                    {{
                      this.studentDetails && this.studentDetails.enquiryCode
                      ? this.studentDetails.enquiryCode
                      : 'N/A'
                    }}<br /></span>
                  <span>:
                    {{
                      this.studentDetails && this.studentDetails.name
                      ? this.studentDetails.name
                      : 'N/A'
                    }}</span><br />
                  <span>:
                    {{
                      this.studentDetails && this.studentDetails.franchisee
                      ? this.studentDetails.franchisee.companyName
                      : 'N/A'
                    }}</span><br />
                  <span>:
                    {{
                      this.studentDetails && this.studentDetails.academicYear
                      ? this.studentDetails.academicYear.academicYear
                      : 'N/A'
                    }}</span><br />
                  <span>:
                    {{
                      this.studentDetails && this.studentDetails.class
                      ? this.studentDetails.class
                      : 'N/A'
                    }}</span><br />
                  <span>:
                    {{
                      this.studentDetails && this.studentDetails.applicationCode
                      ? this.studentDetails.applicationCode
                      : 'N/A'
                    }}</span><br />
                  <span v-if="studentDetails.gender === 'Female' ||
                      studentDetails.gender === 'FEMALE'
                      ">:
                    {{
                      studentDetails &&
                      studentDetails.gender &&
                      studentDetails.gender === 'Female'
                      ? 'Girl'
                      : '-' ||
                        (studentDetails &&
                          studentDetails.gender &&
                          studentDetails.gender === 'FEMALE')
                        ? 'Girl'
                        : '-'
                    }}</span>
                  <span v-if="studentDetails.gender === 'Male' ||
                        studentDetails.gender === 'MALE'
                        ">:
                    {{
                      studentDetails &&
                      studentDetails.gender &&
                      studentDetails.gender === 'Male'
                      ? 'Boy'
                      : '-' ||
                        (studentDetails &&
                          studentDetails.gender &&
                          studentDetails.gender === 'MALE')
                        ? 'Boy'
                        : '-'
                    }}</span>
                  <span v-if="studentDetails.gender === null" class="mb-1">: N/A</span>
                  <br />
                  <span>:
                    {{
                      this.studentDetails && this.studentDetails.section
                      ? this.studentDetails.section
                      : 'N/A'
                    }}</span><br />
                  <span>:
                    {{
                      this.studentDetails && this.studentDetails.enrollmentCode
                      ? this.studentDetails.enrollmentCode
                      : 'N/A'
                    }}</span><br />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="6" style="padding: 0 0 25px 0">
                  <div v-if="isFatherData">
                    <span><b>Father's Name</b></span><br />
                    <span><b>Father's Mobile</b></span><br />
                    <span><b>Father's Email</b></span>
                  </div>
                  <br />
                  <div v-if="isMotherData">
                    <span><b>Mother's Name</b></span><br />
                    <span><b>Mother's Mobile</b></span><br />
                    <span><b>Mother's Email</b></span>
                  </div>
                  <br />
                </v-col>
                <v-col cols="6">
                  <div v-if="isFatherData">
                    <span>:
                      {{
                        this.studentDetails && this.studentDetails.fatherName
                        ? this.studentDetails.fatherName
                        : 'N/A'
                      }}</span><br />
                    <span>:
                      {{
                        this.studentDetails && this.studentDetails.fatherMobile
                        ? this.studentDetails.fatherMobile
                        : 'N/A'
                      }}</span><br />
                    <span>:
                      {{
                        this.studentDetails && this.studentDetails.fatherEmailID
                        ? this.studentDetails.fatherEmailID
                        : 'N/A'
                      }}</span>
                  </div>
                  <br />
                  <div v-if="isMotherData">
                    <span>:
                      {{
                        this.studentDetails && this.studentDetails.motherName
                        ? this.studentDetails.motherName
                        : 'N/A'
                      }}</span><br />
                    <span>:
                      {{
                        this.studentDetails && this.studentDetails.motherMobile
                        ? this.studentDetails.motherMobile
                        : 'N/A'
                      }}</span><br />
                    <span>:
                      {{
                        this.studentDetails && this.studentDetails.motherEmailID
                        ? this.studentDetails.motherEmailID
                        : 'N/A'
                      }}</span>
                  </div>
                  <br />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <br />
          <table width="100%" style="border: 1px solid black">
            <thead>
              <tr style="border: 1px solid black">
                <th style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Sr.no
                </th>
                <th style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Date
                </th>
                <th style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Receipt No.
                </th>
                <th style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Particulars
                </th>
                <th style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Mode of Payment
                </th>
                <th style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(transaction, index) in paymentOrderData" :key="index" style="border: 1px solid black">
                <td style="padding: 5px 10px 5px 10px">{{ index + 1 }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  {{ transaction.createdAt ? transaction.createdAt : 'NA' }}
                </td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  {{ transaction.receiptNo ? transaction.receiptNo : 'NA' }}
                </td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  {{ transaction.notes ? transaction.notes.type : 'NA' }}
                </td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  {{ transaction.paymentMode ? transaction.paymentMode : 'NA' }}
                </td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  {{ transaction.amount ? transaction.amount.toFixed(2) : 'NA' }}
                </td>
              </tr>
            </tbody>
            <tfoot class="">
              <tr>
                <th style="text-align: right; border: 1px solid black" colspan="5">
                  Total Amount
                </th>
                <td style="padding: 5px 10px 5px 10px">{{ totalPayment.toFixed(2) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <v-row>
          <v-col cols="12" style="padding: 25px 0 0px 25px">
            <span class="note">Disclaimer : This is a consolidation fee receipt.</span>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import moment from 'moment'
import _ from 'lodash'
export default {
  name: 'Invoice',
  props: ['sendCaptureRespos'],
  data () {
    return {
      captureData: [],
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      studentDetails: '',
      franchiseeLogo: '',
      currentDate: moment.now(),
      paymentOrderData: [],
      isMotherData: false,
      isFatherData: false
    }
  },
  async created () {
    await this.getInvoiceData()
    if (this.franchiseeLogo) {
      console.log(`Franchisee Logo: ${this.franchiseeLogo}`)
      if (!this.franchiseeLogo.includes('https')) {
        // If logo is not converted to signed URL in the backend
        this.franchiseeLogo = await this.getS3Url(this.franchiseeLogo)
      }
    } else {
      this.franchiseeLogo = `${constants.RAZORPAY.TOTS_IMAGE}`
    }
  },
  methods: {
    moment: function (value) {
      return moment(value).format('YYYY/MM/DD')
    },
    getInvoiceData: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        if (
          this.sendCaptureRespos &&
          this.sendCaptureRespos.studentInfo.franchisee.franchiseeLogo
        ) {
          this.franchiseeLogo =
            this.sendCaptureRespos.studentInfo.franchisee.franchiseeLogo
        }
        this.studentDetails = this.sendCaptureRespos.studentInfo
        this.studentDetails.name =
          this.studentDetails.studentFirstName +
          ' ' +
          this.studentDetails.studentMiddleName +
          ' ' +
          this.studentDetails.studentLastName
        this.paymentOrderData = this.sendCaptureRespos.paymentOrderData
        this.paymentOrderData = _.map(this.paymentOrderData, (obj) => {
          if (
            obj.paymentMode !== 'Fee_adjusted' &&
            obj.paymentMode !== 'Refund To Franchisee'
          ) {
            return obj
          }
        })
        this.paymentOrderData = _.remove(this.paymentOrderData, undefined)
        var amount = 0
        var enrollmentCode = ''
        for (let index = 0; index < this.paymentOrderData.length; index++) {
          amount += this.paymentOrderData[index].amount
          if (this.paymentOrderData[index].notes) {
            this.paymentOrderData[index].notes.type = constants.UserReferenceType.tutionFees
            enrollmentCode = this.paymentOrderData[index].notes.enrollmentCode
              ? this.paymentOrderData[index].notes.enrollmentCode
              : 'NA'
          }
        }
        if (this.studentDetails.fatherName) {
          this.isFatherData = true
        }
        if (this.studentDetails.motherName) {
          this.isMotherData = true
        }
        this.studentDetails.enrollmentCode = enrollmentCode
        this.totalPayment = amount / 100
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getS3Url: async function (key) {
      try {
        let response = await http.get(
          `${constants.API_URL}/api/ticket/downloadurl?s3urlKey=${key}`
        )
        return response.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error', errorMessage)
        return errorMessage
      }
    }
  }
}
</script>

<style scoped>
@page {
  size: auto;
  margin: 5mm;
}

.note {
  font-size: 10px !important;
  font-weight: 500 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.cashier {
  text-align: right !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.cash {
  font-size: 14px !important;
  font-weight: 500;
}

.v-container {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.top-heading {
  margin-right: 4px !important;
}

.franchisee-name {
  font-size: 16px !important;
}

.flex-content {
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
}

table {
  padding: 2px !important;
}

table tr td,
table tr th {
  border: 1px solid #000 !important;
  font-size: 12px !important;
  color: #000 !important;
  padding: 2px !important;
}

span {
  color: #000 !important;
}

.text {
  font-size: 12px;
}

.dotted {
  border-bottom-style: dotted;
}

.divider {
  margin-top: 6px;
  margin-bottom: 0;
  background: #000 !important;
  color: #000 !important;
  border: 1px solid #000 !important;
}

@media print {

  #printableArea,
  #printableArea * {
    visibility: visible;
  }

  #printableArea {
    position: absolute;
    left: 0;
    top: 0;
  }

  #printableArea1,
  #printableArea1 * {
    visibility: visible;
  }

  #printableArea1 {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
